import { DefaultEditor, ViewCell } from 'ng2-smart-table';
import { Component, OnInit } from '@angular/core';
import { CustomCriteriaService } from './customCriteriaService';




/**
 * Componente que renderiza la celda Valor Traducido en la tabla de customform
 */
@Component({
  template: `
  <ng-container>
  <div style="display: inline-flex;">
    <label>{{this.valorTraducido}}</label>
  </div>
  </ng-container>
  `,
})
export class ValorTraducidoComponent implements ViewCell, OnInit {

  constructor (private modalService: CustomCriteriaService){

  }
  value: string | number | any;
  valorTraducido: string
  rowData: any;
  visible: boolean;


  currentValueVT: any;
  fieldEnabled = false;
  availableFields: any = {
    'CriteriosValid': ['date','date_range','datetime','datetime_range','hour','hours','number'],
  }

  ngOnInit(): void {


      this.valorTraducido = this.modalService.validaExpresion(this.value,this.rowData.type)
      if(!this.valorTraducido.startsWith("Valor ")){
          this.valorTraducido = '';
      }
  }

}

